/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
// eslint-disable-next-line no-unused-vars
import {
    GitLabStatusSync,
    GitLabStatusSyncFromJSON,
    GitLabStatusSyncToJSON,
} from './';

/**
 * 
 * @export
 * @interface GitLab
 */
export interface GitLab {
    /**
     * 
     * @type {string}
     * @memberof GitLab
     */
    gitlabInstanceUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof GitLab
     */
    projectId: number;
    /**
     * 
     * @type {string}
     * @memberof GitLab
     */
    projectPath: string;
    /**
     * 
     * @type {string}
     * @memberof GitLab
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GitLab
     */
    createWithCategoryId: string;
    /**
     * 
     * @type {string}
     * @memberof GitLab
     */
    initialStatusId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GitLab
     */
    createWithTags?: Array<string>;
    /**
     * 
     * @type {GitLabStatusSync}
     * @memberof GitLab
     */
    statusSync?: GitLabStatusSync;
    /**
     * 
     * @type {boolean}
     * @memberof GitLab
     */
    responseSync?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GitLab
     */
    commentSync?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GitLab
     */
    createReleaseWithCategoryId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GitLab
     */
    releaseNotifyAll?: boolean;
}

export function GitLabFromJSON(json: any): GitLab {
    return {
        'gitlabInstanceUrl': !exists(json, 'gitlabInstanceUrl') ? undefined : json['gitlabInstanceUrl'],
        'projectId': json['projectId'],
        'projectPath': json['projectPath'],
        'name': json['name'],
        'createWithCategoryId': json['createWithCategoryId'],
        'initialStatusId': !exists(json, 'initialStatusId') ? undefined : json['initialStatusId'],
        'createWithTags': !exists(json, 'createWithTags') ? undefined : json['createWithTags'],
        
        'statusSync': !exists(json, 'statusSync') ? undefined : GitLabStatusSyncFromJSON(json['statusSync']),
        'responseSync': !exists(json, 'responseSync') ? undefined : json['responseSync'],
        'commentSync': !exists(json, 'commentSync') ? undefined : json['commentSync'],
        'createReleaseWithCategoryId': !exists(json, 'createReleaseWithCategoryId') ? undefined : json['createReleaseWithCategoryId'],
        'releaseNotifyAll': !exists(json, 'releaseNotifyAll') ? undefined : json['releaseNotifyAll'],
    };
}

export function GitLabToJSON(value?: GitLab): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'gitlabInstanceUrl': value.gitlabInstanceUrl,
        'projectId': value.projectId,
        'projectPath': value.projectPath,
        'name': value.name,
        'createWithCategoryId': value.createWithCategoryId,
        'initialStatusId': value.initialStatusId,
        'createWithTags': value.createWithTags,
        
        'statusSync': GitLabStatusSyncToJSON(value.statusSync),
        'responseSync': value.responseSync,
        'commentSync': value.commentSync,
        'createReleaseWithCategoryId': value.createReleaseWithCategoryId,
        'releaseNotifyAll': value.releaseNotifyAll,
    };
}


